import FilterToggle from "./FilterToggle";
import { GoDownload } from "react-icons/go";
import { IoDocumentTextOutline } from "react-icons/io5";
import { useTranslation } from "react-i18next";

const MonthlyReportAll = ({ filter, dateFrom, dateTo, onFilterChange, onCustomClick, onClearDates, onExport }) => {
    const { t } = useTranslation();
    return (
        <div className="bg-primary-800 border border-primary-50 rounded-2xl p-4 mb-3">
            <div className="flex mb-4 items-center">
                <div className="rounded-xl p-2 text-2xl bg-secondary-50 text-secondary-800">
                    <IoDocumentTextOutline />
                </div>
                <div className="ml-2">
                    <h3 className="text-white ">
                    {t('reports.monthly_report')}
                    </h3>
                    <p className="text-primary-10 text-xs">{t('reports.monthly_report_desc')}</p>
                </div>
            </div>
            <FilterToggle
                value={filter}
                dateFrom={dateFrom}
                dateTo={dateTo}
                onChange={onFilterChange}
                onCustomClick={onCustomClick}
                onClearDates={onClearDates}
            />
            <button className="flex w-full items-center justify-center rounded-xl bg-secondary-800 text-white text-sm font-bold mt-3 py-3"
            onClick={onExport}>
                <GoDownload /> {t('reports.export_telegram')}
            </button>
        </div>
    );
};

export default MonthlyReportAll;